export interface HolidayTypeClass {
    AccountHolidayTypeId: number
    ParentAccountHolidayTypeId:number
    IsParent:boolean
    AccountId: number
    MasterHolidayTypeId: number
    AccountHolidayType: string
    CreatedOn: Date | undefined
    CreatedByEmployeeId: number
    ModifiedOn: Date | undefined
    ModifiedByEmployeeId: number
    IsDisabled: boolean
    IsDeleted: boolean
    isSelected:number
}

export const holidayTypeInitialsForAdd = {
    AccountHolidayType: "",
    ParentAccountHolidayTypeId:"00000000-0000-0000-0000-000000000000",
    IsDisabled: false,
    IsParent: false
}

export const holidayTypeInitialsForUpdate = {
    AccountHolidayType: "",
    AccountHolidayTypeId: "",
    ParentAccountHolidayTypeId:"00000000-0000-0000-0000-000000000000",
    IsDisabled: false,
    IsParent:false
}